// extracted by mini-css-extract-plugin
module.exports = {"container":"_2wKIyQLJU9ePG3tcr4MxO5","list":"_2DvjNphgxwZ4RAuL3892Df","font_p":"_1dbtYep4OZRt4WXRhsctD7","button":"h9kz1hr2BdieAaJHQr-TG"};